// Structural data for services, reviews, trust indicators, and steps.
// Text content lives in src/i18n/translations.js and is referenced here by key.

export const services = [
  {
    id: 1,
    key: "plumbing",
    imageUrls: [
      "/images/services/plumbing-1.jpg",
      "/images/services/plumbing-2.jpg",
      "/images/services/plumbing-3.jpg"
    ],
    avgRating: 4.9,
    reviewCount: 127
  },
  {
    id: 2,
    key: "electrical",
    imageUrls: [
      "/images/services/electrical-1.jpg",
      "/images/services/electrical-2.jpg",
      "/images/services/electrical-3.jpg"
    ],
    avgRating: 4.8,
    reviewCount: 89
  },
  {
    id: 3,
    key: "drywall",
    imageUrls: [
      "/images/services/drywall-1.jpg",
      "/images/services/drywall-2.jpg",
      "/images/services/drywall-3.jpg"
    ],
    avgRating: 4.9,
    reviewCount: 156
  },
  {
    id: 4,
    key: "flooring",
    imageUrls: [
      "/images/services/flooring-1.jpg",
      "/images/services/flooring-2.jpg",
      "/images/services/flooring-3.jpg"
    ],
    avgRating: 4.7,
    reviewCount: 73
  },
  {
    id: 5,
    key: "smartHome",
    imageUrls: [
      "/images/services/smarthome-1.jpg",
      "/images/services/smarthome-2.jpg",
      "/images/services/smarthome-3.jpg"
    ],
    avgRating: 4.8,
    reviewCount: 94
  },
  {
    id: 6,
    key: "emergency",
    imageUrls: [
      "/images/services/emergency-1.jpg",
      "/images/services/emergency-2.jpg",
      "/images/services/emergency-3.jpg"
    ],
    avgRating: 4.9,
    reviewCount: 201
  }
];

export const reviews = [
  { id: 1, name: "Sarah Johnson", rating: 5, key: "r1", serviceId: 1, date: "2024-01-15" },
  { id: 2, name: "Mike Chen", rating: 5, key: "r2", serviceId: 2, date: "2024-01-10" },
  { id: 3, name: "Jennifer Martinez", rating: 5, key: "r3", serviceId: 3, date: "2024-01-08" },
  { id: 4, name: "David Thompson", rating: 4, key: "r4", serviceId: 4, date: "2024-01-05" },
  { id: 5, name: "Lisa Wang", rating: 5, key: "r5", serviceId: 5, date: "2024-01-03" },
  { id: 6, name: "Robert Davis", rating: 5, key: "r6", serviceId: 6, date: "2023-12-28" },
  { id: 7, name: "Amanda Foster", rating: 5, key: "r7", serviceId: null, date: "2023-12-25" },
  { id: 8, name: "James Wilson", rating: 4, key: "r8", serviceId: 2, date: "2023-12-20" }
];

export const trustIndicators = [
  { key: "response" },
  { key: "quotes" },
  { key: "craftsmanship" },
  { key: "respectful" }
];

export const howItWorksSteps = [
  { step: 1, key: "request" },
  { step: 2, key: "schedule" },
  { step: 3, key: "done" }
];
